import api from "./axios";

export const messageRequestStatusApi = async ({ aec_id, status }) => {
  const payload = new FormData();
  payload.append("id", aec_id);
  payload.append("status", status); // 2, 3, or 4

  const { data } = await api.post(
    "/chat/message-request-status-update/",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  if (!data.success) throw new Error(data.message || "Failed to update status");
  return data.data || {};
};
